import { ProvidersEnabled } from 'src/atoms/mobility'

export const getAlphaMapOnlyProviderStats = <T>(data: T): Record<keyof ProvidersEnabled, T> => {
  return {
    alphamap: data,
    advan: {} as T,
    olvin: {} as T,
    unacast: {} as T,
    unacast_vdp: {} as T,
  }
}
